module.exports = __webpack_public_path__ + "static/media/drag.d4eb5d44.svg";